import { FILE_KEY } from "@pdfking/constants/alias"
import { FILE_NOT_FOUND } from "@pdfking/translations/enum/errors"
import length from "rfuncs/functions/length"

export type DispatchData = {
  url: string
  actions: Record<string, [string, ...any]>
  meta: Record<string, any>
  file_data: Record<string, any>[]
  destinations: Record<string, any>
  total_media_pages: number
  imposition_id: string
}

export default async (url: string): Promise<DispatchData> => {
  const response = await fetch(url)

  if (response.status > 300) {
    throw FILE_NOT_FOUND
  }

  const data = await response.json()

  if (!data.actions) {
    throw `URL must return actions, probably the imposition is truncated or invalid: ${url}`
  }

  return {
    url,
    meta: data.meta,
    actions: data.actions,
    file_data: data.forms.data[FILE_KEY],
    destinations: data.meta ? data.meta.destinations : {},
    total_media_pages: data.meta ? length(data.meta.media) : 0,
    imposition_id: data.imposition_id,
  }
}
